"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.branch.list': 'Branches',
    'route.branch.create': 'Add Branch',
    'route.branch.edit': 'Edit Branch',
};
